import type {
  AutopilotTaskDto,
  TaskCategoryStage,
  TaskCategoryWorkflowType,
  TaskStepDto,
} from '@urbanx/agx.activities.client'

export const shouldConfirmSingleStepCompletion = (
  taskSteps: TaskStepDto[],
  step: TaskStepDto
) => taskSteps.length === 1 && step.isCompleted !== true

const isSameTask = (left: AutopilotTaskDto, right: AutopilotTaskDto) =>
  left.id !== undefined && left.id === right.id

export const isLastIncompleteTaskInStage = ({
  task,
  tasks,
  stage,
  workflowType,
}: {
  task?: AutopilotTaskDto
  tasks: AutopilotTaskDto[]
  stage: TaskCategoryStage
  workflowType?: TaskCategoryWorkflowType
}) => {
  if (!task) return false

  const resolvedWorkflowType = workflowType ?? task.category?.workflowType
  if (!resolvedWorkflowType) return false

  const incompleteStageTasks = tasks.filter(
    (candidate) =>
      candidate.category?.workflowType === resolvedWorkflowType &&
      candidate.category?.stage === stage &&
      candidate.isCompleted !== true
  )

  return (
    incompleteStageTasks.length === 1 &&
    isSameTask(incompleteStageTasks[0], task)
  )
}
